<template>
  <div>
    <div class="overview-box">
      <div class="title">{{ title }}{{ rangeName }}数据历史人数走势</div>
      <div class="flex flex-end">
        <el-date-picker
          clearable
          v-model="searchCondition.createTimeArry"
          type="daterange"
          align="right"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          size="small"
          class="mr10"
          @change="createTimeArryChange"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </div>
      <div>
        <div id="main" style="height: 400px"></div>
      </div>
    </div>
    <div class="overview-box">
      <div class="flex flex-between">
        <div class="title">{{ title }}人群分布</div>
        <div style="color: #999; font-size: 14px">
          计算于：{{ computationTime }}
        </div>
      </div>
      <div>
        <div
          v-show="options.xAxis.data.length"
          id="mains"
          style="height: 400px"
        ></div>
        <div
          class="flex flex-center item-center gray"
          v-if="options.xAxis.data.length === 0"
          style="height: 400px"
        >
          暂无人群统计数据，初次设置明日查看
        </div>
      </div>
    </div>
    <hm-content ref="hmcontent" class="overview-box">
      <div class="title">{{ title }}{{ rangeName }}会员详细</div>
      <div class="flex flex-end">
        <el-button
          size="small"
          type="primary"
          @click="output('会员详细')"
          :loading="isOutputing"
          >导出会员详细</el-button
        >
      </div>
      <div class="mt10">
        <el-table
          stripe
          ref="table"
          :data="list"
          style="width: 100%"
          id="table"
          size="small"
          max-height="300"
        >
          <el-table-column
            type="index"
            label="序号"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="nickName"
            label="会员昵称"
            column-key="nickName"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realName"
            label="会员姓名"
            column-key="realName"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="mobile"
            label="会员手机号"
            column-key="mobile"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="familyBirthday"
            :label="
              searchCondition.groupType === 'baby' ? '宝宝生日' : '预产期'
            "
            column-key="familyBirthday"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="tagValue"
            :label="
              searchCondition.groupType === 'baby' ? '宝宝标签值' : '孕妇标签值'
            "
            column-key="tagValue"
            class="flex flex-center"
          >
            <template slot-scope="scope">
              <div class="flex flex-center">
                <span>{{ scope.row.tagValue }}</span>
                <div class="flex feedback" @click="openRults(scope.row)">
                  <span class="el-icon-message"></span>
                  <span>反馈</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="guideName"
            label="归属导购"
            column-key="guideName"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="departName"
            label="归属门店"
            column-key="departName"
          >
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>

      <el-dialog :visible.sync="dialogVisible" style="border:none;">
        <div class="contain flex">
          <div class="flex result flex-center item-center">
            <span class="icon el-icon-message"></span>
          </div>
          <div class="tips">标签值反馈</div>
          <div class="operation">
            <el-button type="primary" @click="notTag"
              >该会员不是此标签</el-button
            >
            <el-button
              type="info"
              plain
              class="ml10"
              @click="dialogVisible = false"
              >暂不处理</el-button
            >
          </div>
        </div>
      </el-dialog>
    </hm-content>
  </div>
</template>

<script>
import moment from "moment";
import echarts from "echarts";
// var echarts = require("echarts/lib/echarts");
// require("echarts/lib/chart/bar");
// // 引入提示框和图例组件
// require("echarts/lib/component/tooltip");
// require("echarts/lib/component/title");
// require("echarts/lib/component/legend");

export default {
  components: {},
  data() {
    return {
      isOutputing: false,
      computationTime: moment(new Date())
        .add(-1, "days")
        .format("YYYY-MM-DD HH:mm:ss"),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          }
          // {
          //   text: "最近一个月",
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          //     picker.$emit("pick", [start, end]);
          //   }
          // },
          // {
          //   text: "最近三个月",
          //   onClick(picker) {
          //     const end = new Date();
          //     const start = new Date();
          //     start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          //     picker.$emit("pick", [start, end]);
          //   }
          // }
        ]
      },
      total: 0,
      name: "",
      dialogVisible: false,
      list: [],
      pageSize: 10,
      currentPage: 1,
      options: {
        // ---  提示框 ----
        tooltip: {
          formatter: function(params) {
            var relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              relVal +=
                "<br/>" +
                params[i].marker +
                // params[i].seriesName +
                // " : " +
                params[i].value +
                "人";
            }
            return relVal;
          },
          show: true, // 是否显示提示框，默认为true
          trigger: "axis", // 数据项图形触发
          axisPointer: {
            // 指示样式
            type: "shadow",
            axis: "auto"
          },
          padding: 5,
          textStyle: {
            // 提示框内容的样式
            color: "#fff"
          }
        },
        xAxis: {
          axisTick: {
            // 坐标轴 刻度
            show: false, // 是否显示
            inside: true, // 是否朝内
            length: 3, // 长度
            lineStyle: {
              // 默认取轴线的样式
              color: "red",
              width: 1,
              type: "solid"
            }
          },
          type: "category",
          data: []
        },
        yAxis: {
          type: "value",
          minInterval: 1
        },
        dataZoom: [
          {
            start: 0,
            type: "inside"
          },
          {
            start: 9
          }
        ],
        series: [
          {
            barWidth: "70%", // 柱形的宽度
            barCategoryGap: "30%", // 柱形的间距
            data: [],
            type: "bar"
          }
        ]
      },
      option: {
        // ---  提示框 ----
        tooltip: {
          show: true, // 是否显示提示框，默认为true
          trigger: "item", // 数据项图形触发
          axisPointer: {
            // 指示样式
            type: "shadow",
            axis: "auto"
          },
          padding: 5,
          textStyle: {
            // 提示框内容的样式
            color: "#fff"
          }
        },
        xAxis: {
          type: "category",
          data: []
        },
        yAxis: {
          type: "value"
        },
        dataZoom: [
          {
            start: 0,
            type: "inside"
          },
          {
            start: 9
          }
        ],
        series: [
          {
            barWidth: "50%", // 柱形的宽度
            barCategoryGap: "30%", // 柱形的间距
            data: [],
            type: "bar"
          }
        ]
      },
      searchCondition: {
        createTimeArry: []
      },

      rangeName: this.$route.query.rangeName,
      title: "孕妇群体",
      rangeList: [],
      rangeDate: "",
      row: {}
      // axisId: JSON.parse(this.$route.query.searchCondition).axisId
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.searchCondition.createTimeArry = [
      moment(new Date())
        .add(-7, "days")
        .format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    ];
    Object.assign(
      this.searchCondition,

      JSON.parse(this.$route.query.searchCondition)
    );
    this.title =
      this.searchCondition.groupType === "baby" ? "宝宝群体" : "孕妇群体";
    this.categoryLine();
    this.distributionLine();
  },
  methods: {
    async notTag() {
      await this.$store.dispatch("queryTagDelete", {
        source: "detail",
        ids: this.row.tagRecordId,
        state: "0"
      });
      this.$message({
        message: "操作成功",
        type: "warning"
      });
      this.dialogVisible = false;
      this.queryList();
    },
    // 导出excel
    async output() {
      const params = {
        pageSize: 99999,
        pageNo: 1
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.rangeDate = this.rangeDate;
      Object.assign(params, searchCondition);

      await this.$store.dispatch("physiologicalDataExport", searchCondition);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success"
        });
        this.$refs.hmcontent.flag = false;
      }, 0);
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    createTimeArryChange() {
      this.categoryLine();
    },
    seeResults() {},
    openRults(row) {
      console.log(row);
      this.row = row;
      this.dialogVisible = true;
    },
    async distributionLine() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // setTimeout(() => {
      const { code, result } = await this.$store.dispatch(
        "queryAgeGroupDistribution",
        searchCondition
      );
      if (code === "0") {
        let time = [];
        let data = [];
        result.forEach(v => {
          time.push(v.axisName);
          data.push(v.number);
        });
        console.log("result: ", result);
        this.options.xAxis.data = time;
        this.options.series[0].data = data;
        this.$nextTick(() => {
          const myChart = echarts.init(document.getElementById("mains"));
          myChart.setOption(this.options);
          myChart.getZr().on("click", params => {
            let pointInPixel = [params.offsetX, params.offsetY];
            if (myChart.containPixel("grid", pointInPixel)) {
              let xIndex = myChart.convertFromPixel({ seriesIndex: 0 }, [
                params.offsetX,
                params.offsetY
              ])[0];
              console.log(xIndex);
            }
          });
        });
      }
    },
    async categoryLine() {
      if (
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
      ) {
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        searchCondition.startDate =
          this.searchCondition.createTimeArry &&
          this.searchCondition.createTimeArry.length > 0
            ? this.searchCondition.createTimeArry[0] + " 00:00:00"
            : null;
        searchCondition.endDate =
          this.searchCondition.createTimeArry &&
          this.searchCondition.createTimeArry.length > 0
            ? this.searchCondition.createTimeArry[1] + " 23:59:59"
            : null;
        const { code, result } = await this.$store.dispatch(
          "queryPhysiologicalMemberRangeList",
          searchCondition
        );

        if (code === "0") {
          let rangeDate = [];
          let memberNumber = [];
          result.forEach(v => {
            rangeDate.push(v.rangeDate.split(" ")[0]);
            memberNumber.push(v.memberNumber);
          });
          this.rangeList = result;
          this.rangeDate = this.rangeList[this.rangeList.length - 1].rangeDate;
          this.queryList();
          // this.option.xAxis.data = rangeDate;
          // this.option.series[0].data = memberNumber;
          // setTimeout(() => {
          this.$nextTick(() => {
            let that = this;
            let myChart = echarts.init(document.getElementById("main"));
            // myChart.setOption(this.option);
            myChart.setOption({
              // ---  提示框 ----
              tooltip: {
                // formatter: `${params[i].marker} {b0}:{c0}人`,
                formatter: function(params) {
                  var relVal = params[0].name;
                  for (var i = 0, l = params.length; i < l; i++) {
                    relVal +=
                      "<br/>" +
                      params[i].marker +
                      // params[i].seriesName +
                      // " : " +
                      params[i].value +
                      "人";
                  }
                  return relVal;
                },
                show: true, // 是否显示提示框，默认为true
                trigger: "axis", // 数据项图形触发
                axisPointer: {
                  // 指示样式
                  type: "shadow",
                  axis: "auto"
                },
                padding: 5,
                textStyle: {
                  // 提示框内容的样式
                  color: "#fff"
                }
              },
              xAxis: {
                type: "category",
                data: rangeDate
              },
              yAxis: {
                type: "value"
              },
              dataZoom: [
                {
                  start: 0,
                  type: "inside"
                },
                {
                  start: 9
                }
              ],
              series: [
                {
                  barWidth: "50%", // 柱形的宽度
                  barCategoryGap: "30%", // 柱形的间距
                  data: memberNumber,
                  type: "bar"
                }
              ]
            });
            // myChart.getZr().on("click", params => {
            //   let pointInPixel = [params.offsetX, params.offsetY];
            //   if (myChart.containPixel("grid", pointInPixel)) {
            //     let xIndex = myChart.convertFromPixel({ seriesIndex: 0 }, [
            //       params.offsetX,
            //       params.offsetY
            //     ])[0];
            //     console.log(xIndex);
            //   }
            // });
            myChart.on("click", function(params) {
              if (that.rangeList.length) {
                that.rangeDate = that.rangeList[params.dataIndex].rangeDate;
                that.queryList();
              }
            });
          });

          // }, 1000);
          // console.log("result: ", result);
        }
      } else {
        this.$message({
          message: "请选择查询时间段",
          type: "warning"
        });
      }
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.rangeDate = this.rangeDate;
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryMemberRangeDetailList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        // records.forEach(v => {
        //   v.proportion = v.totalNoticeNum
        //     ? ((v.payNum / v.noticeNum) * 100).toFixed(2) + "%"
        //     : "0%";
        // });
        this.list = records;
        this.total = total;
      }
    },
    async queryAllList() {
      const params = {
        pageSize: 99999,
        pageNo: 1
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.rangeDate = this.rangeDate;
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryMemberRangeDetailAllList",
        params
      );
      if (code === "0") {
        return result.records;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss">
.overview-box {
  background: #fff;
  margin-bottom: 10px;
  padding: 20px;
  .title {
    color: #222222;
    font-weight: bold;
    &::before {
      display: inline-block;
      margin-right: 5px;
      content: "";
      width: 4px;
      height: 14px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
  .tit {
    // margin-top: 20px;
    color: #222;
    line-height: 40px;
    font-weight: bold;
    font-size: 20px;
  }
  .item-tip {
    color: #222;
    line-height: 24px;
    font-size: 14px;
  }
}
.feedback {
  align-items: baseline;
  color: #ff7f10;
  margin-left: 10px;
  cursor: pointer;
}
.contain {
  flex-direction: column;
  align-items: center;
  .result {
    width: 56px;
    height: 56px;
    border-radius: 100%;
    background: #ff7f10;
    .icon {
      color: #ffffff;
      font-size: 35px;
    }
  }
  .tips {
    color: #ff7f10;
    font-size: 16px;
    margin-top: 18px;
    font-weight: 500;
  }
  .operation {
    margin-top: 35px;
    margin-bottom: 20px;
  }
}
</style>

<style lang="scss">
.el-dialog__wrapper {
  .el-dialog {
    .el-dialog__header {
      border: none !important;
    }
  }
}
</style>
